module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-rnd-our-six-digital.fe2565c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-rnd-our-six-digital.jpg
// module id = +E69
// module chunks = 0